import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import { CREDIT_SCORE_PUBLIC_PAGE_ENABLED, CREDIT_KARMA_OFFER_ENABLED } from "@/config/featureFlags";
import { Navigate } from "@/lib/router-compat";
import FreeCreditScore from "@/pages/FreeCreditScore";

export const Route = createFileRoute("/free-credit-score")({
  head: () => seoHead("/free-credit-score"),
  component: () => (!CREDIT_KARMA_OFFER_ENABLED ? <Navigate to="/credit-readiness" replace /> : CREDIT_SCORE_PUBLIC_PAGE_ENABLED ? <FreeCreditScore /> : <Navigate to="/" replace />),
});
